
import React from 'react'
import { arrowright, cu1, cu2, cu3, line, services1, services2, services3, services4, services5, whyus1, whyus2, whyus3 } from '../../assets/imagesPath'
import { cardData } from '../../data/CardData'
import Card from '../../components/Cards/Card'
import ChooseUsCard from '../../components/ChooseUsCards/ChooseusCard'
import { chooseusData } from '../../data/ChooseUsData'
const BusinessAdvisory = () => {
    return (
        <>
            {/* Top Heading: Knowledge Hub */}
            {/* <div className='flex items-center justify-center gap-12 mt-[5.8rem]'>
        <img src={line} alt="" className='h-1 w-7' />
        <p className='text-xl font-bold text-[#818891]'>Services</p>
        <img src={line} alt="" className='h-1 w-7' />
      </div>
      <div className="text-center py-20 px-4 sm:px-6 lg:px-8">
        <h1 className="text-[4.7rem] md:text-[3.4rem] smallScreens:text-[3rem] font-bold text-gray-800">Business Advisory</h1>
      </div> */}

            {/* Section 1: Knowledge Hub */}
            <div className="bg-white py-20 px-4 sm:px-6 lg:px-8">
                <div className="w-4/5 smallScreens:w-full mx-auto smallScreens:mx-0 flex flex-col md:flex-row items-center gap-40">
                    <div className="w-4/5">
                        <div className='flex items-start justify-start gap-12 mt-[5.8rem] smallScreens:mt-0'>
                            <img src={line} alt="" className='h-1 w-7 mt-3 ' />
                            <p className='text-[1.2rem] font-bold text-[#818891] smallScreens:text-[1rem]'>Services</p>
                            <img src={line} alt="" className='h-1 w-7 mt-3' />
                        </div>
                        {/* <div className="text-center py-20 px-4 sm:px-6 lg:px-8">
        <h1 className="text-[4.7rem] md:text-[3.4rem] smallScreens:text-[3rem] font-bold text-gray-800">Business Advisory Services</h1>
      </div>  */}
                        <div className='flex items-start justify-start'>
                            <h1 className='text-[4.7rem] md:text-[3.4rem] smallScreens:text-[3rem] font-bold text-gray-800'>Business Advisory Services</h1>

                        </div>
                        <p className="text-[#64666C] leading-relaxed text-[1.6rem] mt-10 mb-10">
                            At SBAAA LLC, we offer professional, tailored advisory services designed to help small business owners succeed. Whether you’re managing a single trade or multiple LLCs, our expertise can streamline your operations, improve profitability, and simplify your financial decisions.
                        </p>

                    </div>
                    <div className="w-full md:w-2/3 relative smallScreens:px-8">
                        <img
                            src={services1}
                            alt="Professional"
                            className="w-[60.6rem] h-[50.3rem] smallScreens:h-[20rem] object-contain"
                        />
                    </div>
                </div>
            </div>
            <div className=" bg-[#F2F2F282] text-center py-20 px-4 sm:px-6 lg:px-8">
                <div className='flex items-start justify-center gap-12 smallScreens:mt-0'>
                    <img src={line} alt="" className='h-1 w-7 mt-3 ' />
                    <p className='text-[1.2rem] font-bold text-[#818891] smallScreens:text-[1rem] mb-4'>Services</p>
                    <img src={line} alt="" className='h-1 w-7 mt-3' />
                </div>
                <h1 className="text-[5.5rem] md:text-[3.4rem] smallScreens:text-[2.6rem] font-bold text-gray-800">What We Offer</h1>
            </div>
            <div className="bg-[#F2F2F282] py-20 px-4 sm:px-6 lg:px-8">
                <div className="max-w-[900px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-10">
                    {cardData?.map((card, index) => (
                        <Card
                            key={index}
                            imageSrc={card.imageSrc}
                            title={card.title}
                            listItems={card.listItems}
                        />
                    ))}

                    {/* <div className="bg-white px-10 py-14 rounded-2xl shadow-md border border-[#D4D2E3]">
                        <img src={offer1} alt="" className='h-28 smallScreens:mx-auto' />
                        <div className="flex items-center mb-4">
                            <h3 className="text-[#191825] text-[2rem] ml-4 font-bold">
                                Strategic Business Advisory
                            </h3>
                        </div>
                        <ul className="list-decimal list-inside text-[1.6rem] text-[#6A6A6A] space-y-6">
                            <li>Comprehensive business planning and goal setting.</li>
                            <li>Entity structuring and optimization (LLC and S-Corp setups).</li>
                            <li>Profitability analysis and growth strategies.</li>
                        </ul>
                    </div>

                    <div className="bg-white px-10 py-14 rounded-2xl shadow-md border border-[#D4D2E3]">
                        <img src={offer2} alt="" className='h-28 smallScreens:mx-auto' />
                        <div className="flex items-center mb-4">
                            <h3 className="text-[#191825] text-[2rem] ml-4 font-bold my-4">
                                Financial Management Advisory
                            </h3>
                        </div>
                        <ul className="list-decimal list-inside text-[1.6rem] text-[#6A6A6A] space-y-6">
                            <li>Budgeting and cash flow management.</li>
                            <li>Tax planning strategies to maximize savings.</li>
                            <li>Multi-entity financial organization and compliance.</li>
                        </ul>
                    </div>


                    <div className="bg-white px-10 py-14 rounded-lg shadow-md border border-[#D4D2E3]">
                        <img src={offer3} alt="" className='h-28 smallScreens:mx-auto' />
                        <div className="flex items-center mb-4">
                            <h3 className="text-[#191825] text-[2rem] font-bold ml-4 my-4">
                                Customized Solutions for Tradespeople
                            </h3>
                        </div>
                        <ul className="list-decimal list-inside text-[1.6rem] text-[#6A6A6A] space-y-6">
                            <li>Services tailored to electricians, plumbers, remodelers, and other trade professionals..</li>
                            <li>Bookkeeping solutions integrated with financial strategy.</li>
                            <li>Payroll setup and management through trusted platforms like Paychex and ADP.</li>
                        </ul>
                    </div>

                    <div className="bg-white px-10 py-14 rounded-lg shadow-md border border-[#D4D2E3]">
                        <img src={offer4} alt="" className='h-28 smallScreens:mx-auto' />
                        <div className="flex items-center mb-4">
                            <h3 className="text-[#191825] text-[2rem] ml-4 my-4 font-bold">
                                Tax Advisory Services
                            </h3>
                        </div>
                        <ul className="list-decimal list-inside text-[1.6rem] text-[#6A6A6A] space-y-14">
                            <li>Efficient tax planning to minimize liabilities.</li>
                            <li>Collaboration with tax professionals for compliance and optimization.</li>
                        </ul>
                    </div> */}
                </div>

            </div>

            <div className='bg-white '>
                <div className='flex items-center justify-center gap-12 py-6 mt-10 pt-16'>
                    <img src={line} alt="" className='h-1 w-7' />
                    <p className='text-xl font-bold text-[#818891]'>CHOOSE US</p>
                    <img src={line} alt="" className='h-1 w-7' />
                </div>

                <div className='flex items-center justify-center'>
                    <h1 className='font-bold text-[3.4rem] text-center w-2/5 smallScreens:text-[2rem] smallScreens:w-full'>Why Choose Us</h1>
                </div>
                <div className=" py-20 px-4  lg:px-8 smallScreens:px-4">
                    <div className="max-w-[1250px]  mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">


                        {chooseusData.map((card, index) => (
                            <ChooseUsCard
                                key={index}
                                imageSrc={card.imageSrc}
                                title={card.title}
                                description={card.description}
                            />
                        ))}
                    </div>
                    {/* <div className='flex items-center justify-center gap-6 mt-12 py-6'>
                        <button className='rounded-full text-[#173363] border border-[#173363] bg-transparent px-12 py-3 text-[1.6rem] smallScreens:rounded-xl smallScreens:px-16 smallScreens:py-1'>Learn More</button>
                        <button className='bg-[#173363] rounded-full px-14 py-4 text-white text-[1.6rem] smallScreens:rounded-xl smallScreens:px-16 smallScreens:py-2'>Get Started </button>
                    </div> */}
                </div>
            </div>
        </>
    )
}

export default BusinessAdvisory